import * as i0 from '@angular/core';
import { EventEmitter, Component, ChangeDetectionStrategy, Inject, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import * as i3 from '@arematics/core/avatar';
import { AvatarModule } from '@arematics/core/avatar';
import * as i1 from '@arematics/keycloak-angular';
import * as i2 from '@angular/common/http';

class UserImageComponent {
    auth;
    ref;
    http;
    environment;
    loggedInUser = false;
    user;
    fallback = 'assets/no_profile_image.svg';
    /**
     * @deprecated Profile Images shouldn't have a secured endpoint and secure is no longer needed therefor. Consider using Signed image requests if required
     */
    secure = false;
    size = 'normal';
    innerClass = '';
    editable = false;
    changeAvatar = new EventEmitter();
    url;
    label;
    constructor(auth, ref, http, environment) {
        this.auth = auth;
        this.ref = ref;
        this.http = http;
        this.environment = environment;
    }
    ngOnInit() {
        if (this.loggedInUser && this.auth.isLoggedIn() && this.environment.data_api) {
            const uuid = this.auth.getKeycloakInstance().subject;
            if (uuid) {
                this.getProfileImage(uuid);
            }
        }
        else if (this.user) {
            this.getProfileImage(this.user.uid);
        }
        else {
            this.updateImage();
        }
    }
    getProfileImage(uuid) {
        const partial = {
            next: (res) => {
                this.url = URL.createObjectURL(res.body);
                this.ref.markForCheck();
            },
            error: (err) => {
                if (err.status === 404 && err.error instanceof Blob) {
                    this.url = URL.createObjectURL(err.error);
                    this.updateImage();
                    this.ref.markForCheck();
                }
            }
        };
        this.http
            .get(this.environment.data_api + `profile/${uuid}/image`, { observe: 'response', responseType: 'blob' })
            .subscribe(partial);
    }
    updateImage() {
        if (this.user) {
            this.label = this.user.label;
            this.ref.markForCheck();
        }
        else if (this.loggedInUser && this.auth.isLoggedIn()) {
            this.label =
                this.auth.getKeycloakInstance().profile.firstName[0] +
                    this.auth.getKeycloakInstance().profile.lastName[0];
            this.ref.markForCheck();
        }
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: UserImageComponent, deps: [{ token: i1.KeycloakService }, { token: i0.ChangeDetectorRef }, { token: i2.HttpClient }, { token: 'environment' }], target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: UserImageComponent, isStandalone: true, selector: "a-user-image", inputs: { loggedInUser: "loggedInUser", user: "user", fallback: "fallback", secure: "secure", size: "size", innerClass: "innerClass", editable: "editable" }, outputs: { changeAvatar: "changeAvatar" }, ngImport: i0, template: `
		<div class="relative">
			<a-avatar
				[styleClass]="'text-white' + ' ' + innerClass + ' ' + (editable ? 'hoverEdit' : '')"
				[image]="url"
				[label]="label"
				[size]="size"
				(click)="editable ? changeAvatar.emit() : undefined"
				shape="circle">
			</a-avatar>
		</div>
	`, isInline: true, dependencies: [{ kind: "ngmodule", type: CommonModule }, { kind: "ngmodule", type: AvatarModule }, { kind: "component", type: i3.Avatar, selector: "a-avatar", inputs: ["label", "icon", "image", "size", "shape", "style", "styleClass", "ariaLabel", "ariaLabelledBy"], outputs: ["onImageError"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: UserImageComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'a-user-image',
                    standalone: true,
                    imports: [CommonModule, AvatarModule, AvatarModule],
                    template: `
		<div class="relative">
			<a-avatar
				[styleClass]="'text-white' + ' ' + innerClass + ' ' + (editable ? 'hoverEdit' : '')"
				[image]="url"
				[label]="label"
				[size]="size"
				(click)="editable ? changeAvatar.emit() : undefined"
				shape="circle">
			</a-avatar>
		</div>
	`,
                    changeDetection: ChangeDetectionStrategy.OnPush
                }]
        }], ctorParameters: function () { return [{ type: i1.KeycloakService }, { type: i0.ChangeDetectorRef }, { type: i2.HttpClient }, { type: undefined, decorators: [{
                    type: Inject,
                    args: ['environment']
                }] }]; }, propDecorators: { loggedInUser: [{
                type: Input
            }], user: [{
                type: Input
            }], fallback: [{
                type: Input
            }], secure: [{
                type: Input
            }], size: [{
                type: Input
            }], innerClass: [{
                type: Input
            }], editable: [{
                type: Input
            }], changeAvatar: [{
                type: Output
            }] } });

/**
 * Generated bundle index. Do not edit.
 */

export { UserImageComponent };
